import { Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ToastProvider } from './components/toast';
import { RequireAuth } from './auth/RequireAuth';
import LoginPage from './pages/LoginPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DrawingsPage from './pages/DrawingsPage';
import DrawingDetailPage from './pages/DrawingDetailPage';
import UsersAdminPage from './pages/UsersAdminPage';
import UserGroupsPage from './pages/UserGroupsPage';
import ImagesAdminPage from './pages/ImagesAdminPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import SecurityPage from './pages/SecurityPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ToastProvider>
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/change-password"
          element={
            <RequireAuth>
              <ChangePasswordPage />
            </RequireAuth>
          }
        />
        <Route
          path="/security"
          element={
            <RequireAuth>
              <SecurityPage />
            </RequireAuth>
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth>
              <DrawingsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/drawings/:id"
          element={
            <RequireAuth>
              <DrawingDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="/user-groups"
          element={
            <RequireAuth>
              <UserGroupsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/users"
          element={
            <RequireAuth role="admin">
              <UsersAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/images"
          element={
            <RequireAuth role="admin">
              <ImagesAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <RequireAuth role="superadmin">
              <AdminSettingsPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
    </ToastProvider>
  );
}
